import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_WHITE_URL = "https://customer-assets.emergentagent.com/job_mayker-victoria/artifacts/cfvu1wmg_Mayker_Logo_Standard_Colour_Rev.png";

export const Footer = () => {
  return (
    <footer className="bg-[#0C1B33] footer-border" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Column 1: Logo & Contact */}
          <div>
            <img src={LOGO_WHITE_URL} alt="Mayker Financial" className="h-10 mb-4" />
            <p className="text-white/40 text-sm mb-4 italic">
              "Connecting You to Financial Success."
            </p>
            <div className="space-y-2 text-sm text-white/50">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>607 Vancouver Street<br />Victoria, BC</span>
              </div>
              <a href="tel:7788361962" className="flex items-center gap-2 hover:text-[#C9A84C] transition-colors">
                <Phone className="w-4 h-4" />
                778-836-1962
              </a>
              <a href="mailto:chris@maykerfinancial.com" className="flex items-center gap-2 hover:text-[#C9A84C] transition-colors">
                <Mail className="w-4 h-4" />
                chris@maykerfinancial.com
              </a>
            </div>
          </div>

          {/* Column 2: Services */}
          <div>
            <h4 className="text-white font-medium mb-4 text-sm tracking-wide">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/life-insurance" className="text-sm text-white/50 hover:text-[#C9A84C] transition-colors">
                  Life Insurance
                </Link>
              </li>
              <li>
                <Link to="/group-benefits" className="text-sm text-white/50 hover:text-[#C9A84C] transition-colors">
                  Group Benefits
                </Link>
              </li>
              <li>
                <Link to="/financial-planning" className="text-sm text-white/50 hover:text-[#C9A84C] transition-colors">
                  Financial Planning
                </Link>
              </li>
              <li>
                <Link to="/tfsa-investments" className="text-sm text-white/50 hover:text-[#C9A84C] transition-colors">
                  TFSA & Investments
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div>
            <h4 className="text-white font-medium mb-4 text-sm tracking-wide">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-white/50 hover:text-[#C9A84C] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-white/50 hover:text-[#C9A84C] transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-white/50 hover:text-[#C9A84C] transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm text-white/50 hover:text-[#C9A84C] transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: CTA */}
          <div>
            <div className="bg-white/5 border border-[#C9A84C]/20 rounded-lg p-5">
              <h4 className="text-white font-playfair font-semibold mb-2">Book a free call</h4>
              <p className="text-sm text-white/50 mb-4">
                15 minutes. No pressure. Just honest advice.
              </p>
              <Link 
                to="/contact"
                className="block text-center bg-[#C9A84C] text-[#0C1B33] text-sm font-medium py-2.5 rounded hover:bg-[#E8CC80] transition-colors"
              >
                Get Started →
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/30">
          <p>© 2025 Mayker Financial Group Inc. · All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy-policy" className="hover:text-[#C9A84C] transition-colors">
              Privacy Policy
            </Link>
            <span>|</span>
            <a href="https://www.maykerfinancial.com/terms-conditions" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A84C] transition-colors">
              Terms & Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
